import React from 'react'
import { Box, Table, Thead, Tbody, Tr, Th, Text, Flex, Spinner, Select, HStack, FormControl, FormLabel, Tooltip } from '@chakra-ui/react'
import { InfoIcon } from '@chakra-ui/icons'
import { Pagination } from '../../../../components/Pagination'
import Item from './Item'

function ListaProdutos({
  produtos,
  isLoading,
  paginacao,
  onChangePaginacao,
  onChangeLimite,
  onAlterarPrioridade,
  onAbrirModalEditar,
  onAdicionarFoto,
  onDeletarProduto,
  onEditarObservacao,
}) {
  // Opções para limite por página
  const opcoesLimite = [10, 25, 50, 100]

  const handleLimiteChange = (e) => {
    const novoLimite = parseInt(e.target.value)
    onChangeLimite(novoLimite)
  }

  return (
    <Box bg="white" p={4} borderRadius="md" shadow="sm">
      {isLoading ? (
        <Flex justify="center" align="center" height="300px">
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : produtos.length === 0 ? (
        <Flex justify="center" align="center" height="300px">
          <Text>Nenhum produto encontrado.</Text>
        </Flex>
      ) : (
        <>
          <Box overflowX="auto">
            <Table variant="simple" size="sm">
              <Thead>
                <Tr>
                  <Th>Ref. Fornecedor</Th>
                  <Th>Produto</Th>
                  <Th>Fornecedor</Th>
                  <Th>Cod. Inno</Th>
                  <Th>Estoque</Th>
                  <Th>Data API</Th>
                  <Th>Link</Th>
                  <Th>
                    <Tooltip label="Status do link do produto">
                      <Flex alignItems="center">
                        Status Link <InfoIcon ml={1} boxSize="3" />
                      </Flex>
                    </Tooltip>
                  </Th>
                  <Th>
                    <Tooltip label="Status da foto do produto. Clique no ícone para adicionar fotos">
                      <Flex alignItems="center">
                        Status Foto <InfoIcon ml={1} boxSize="3" />
                      </Flex>
                    </Tooltip>
                  </Th>
                  <Th>
                    <Tooltip label="Status do cadastro do produto. Clique no ícone para completar o cadastro">
                      <Flex alignItems="center">
                        Status Cadastro <InfoIcon ml={1} boxSize="3" />
                      </Flex>
                    </Tooltip>
                  </Th>
                  <Th>Prioridade</Th>
                  <Th>Observação</Th>
                  <Th>Ações</Th>
                </Tr>
              </Thead>
              <Tbody>
                {produtos.map((produto) => (
                  <Item
                    key={produto.id}
                    produto={produto}
                    onAlterarPrioridade={onAlterarPrioridade}
                    onAbrirModalEditar={onAbrirModalEditar}
                    onAdicionarFoto={onAdicionarFoto}
                    onDeletarProduto={onDeletarProduto}
                    onEditarObservacao={onEditarObservacao}
                  />
                ))}
              </Tbody>
            </Table>
          </Box>

          <Flex justify="space-between" align="center" mt={6} flexWrap="wrap" gap={2}>
            <Text fontSize="sm">Total: {paginacao.total || 0} produtos</Text>

            <HStack spacing={4}>
              <FormControl display="flex" alignItems="center" w="auto">
                <FormLabel htmlFor="itensPorPagina" mb="0" fontSize="sm" whiteSpace="nowrap">
                  Itens por página:
                </FormLabel>
                <Select
                  id="itensPorPagina"
                  size="sm"
                  w="70px"
                  value={paginacao.por_pagina || paginacao.limite}
                  onChange={handleLimiteChange}
                  isDisabled={isLoading}
                >
                  {opcoesLimite.map((opcao) => (
                    <option key={opcao} value={opcao}>
                      {opcao}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <Pagination
                page={paginacao.pagina_atual || paginacao.pagina}
                setPage={onChangePaginacao}
                limit={paginacao.por_pagina || paginacao.limite}
                totalPages={paginacao.ultima_pagina || Math.ceil((paginacao.total || 0) / paginacao.limite) || 1}
                isDisabled={isLoading}
              />
            </HStack>
          </Flex>
        </>
      )}
    </Box>
  )
}

export default ListaProdutos
